import { Expose } from "class-transformer";
import { DropdownModel } from "./dropdown-model";

export class EjazaModel extends DropdownModel {
    @Expose() id: string;
    @Expose({name: 'ejazaName'}) name: string;

    override get dropDownDisplayName(): string {
        return this.name;
    }

    override get dropDownValue(): Object {
        return this;
    }
}